export const enPrivacyContent = {
    main: 'Ledgerowl takes your privacy and security very seriously. By using our services, you are deemed to have agreed to this privacy policy.',
    contact: {
      email: 'support@ledgerowl.com',
      phone: '+6281287889023',
      address:
        'Cibis Nine Building Lt 15 Unit C, Jl TB Simatupang 2, East Cilandak, Pasar Minggu, South Jakarta, DKI Jakarta 12560',
    },
    data: [
      {
        title: 'What this Privacy Policy Covers',
        titleHref: '#privacypolicycover',
        text2: '',
        text: '',
        list: [
          {
            desc: 'This Privacy Policy covers our treatment of information that can identify you (personal data) when you are on the Ledgerowl site or when using our services. This policy also covers our treatment of personal data shared by us.',
            sublist: [],
          },
          {
            desc: 'This policy does not apply to the practices of companies that are not our group of business units or outside our control or to people who are not our employees or outside our management.',
            sublist: [],
          },
        ],
      },
      {
        title: 'Information Collection',
        text2: '',
        titleHref: '#collection',
        text: 'When you register by filling in your name, email, address, place of residence, date of birth, zip code and telephone number, you will be registered and logged into our service. After registration is done, you are not anonymous to us.',
        list: [],
      },
      {
        title: 'Use of Information',
        text2: '',
        titleHref: '#useinformation',
        text: 'We may use any information you provide, including but not limited to:',
        list: [
          {
            desc: 'Process your information, including but not limited to financial reports, tax filings, sales or purchase invoices, business reports, and others;',
            sublist: [],
          },
          {
            desc: 'Deliver mail or goods that you buy from us;',
            sublist: [],
          },
          {
            desc: 'Inform Product development, sales and maintenance offers or any troubles you may encounter;',
            sublist: [],
          },
          {
            desc: 'Perform payment processing; And',
            sublist: [],
          },
          {
            desc: 'Find out information about your visit, such as when you visited and what you did during the visit.',
            sublist: [],
          },
          {
            desc: 'We may also collect and use your non-personally identifiable data to:',
            sublist: [],
          },
          {
            desc: 'Optimizing Products, Sites, marketing campaigns and more;',
            sublist: [],
          },
          {
            desc: 'Seeing the effectiveness of the Site and Products;',
            sublist: [],
          },
          {
            desc: 'Finding and solving problems that exist on the Site and Products; And',
            sublist: [],
          },
          {
            desc: 'Product Development',
            sublist: [],
          },
        ],
      },
      {
        title: 'Changes to this Privacy Policy',
        titleHref: '#change',
        text2: '',
        text: '',
        list: [
          {
            desc: 'We may change this policy from time to time. If we make major changes in the way we use your personal data, we will notify you by posting a prominent announcement on our pages. You agree that the posting of the announcement is sufficient and sufficient to notify you of the change.',
            sublist: [],
          },
          {
            desc: 'You agree that by continuing to use our products or services after these changes have been made, you accept and agree to be bound by the terms of the new policy.',
            sublist: [],
          },
        ],
      },
      {
        title: 'Disclosure of Your Information',
        text2: '',
        titleHref: '#disclosure',
        text: 'We may disclose your personal information to third parties:',
        list: [
          {
            desc: 'If we sell or buy a business or assets, in which case, we may disclose your personal data to the prospective seller or buyer of the business or assets.',
            sublist: [],
          },
          {
            desc: 'If we have an obligation to disclose or share your personal data in an effort to comply with legal obligations or in an effort to enforce or apply our terms of use and other agreements; or to protect the rights, property or safety of Ledgerowl, our customers or others. This includes exchanging information with other companies and organizations for the purposes of fraud protection and credit risk reduction.',
            sublist: [],
          },
        ],
      },
      {
        title: 'Use of Information',
        titleHref: '#useinformation',
        text2: '',
        text: 'We use the information held about you in the following ways:',
        list: [
          {
            desc: 'To ensure that the content of our site is presented in the most effective manner for you and for your computer.',
            sublist: [],
          },
          {
            desc: 'To provide you with information, products or services that you have requested from us or which we feel may be important to you, where you agree to be contacted for that purpose.',
            sublist: [],
          },
          {
            desc: 'To perform our obligations arising from a contract entered into between you and us.',
            sublist: [],
          },
          {
            desc: 'To enable you to take part in interactive features of our services, when you so choose.',
            sublist: [],
          },
          {
            desc: 'To notify you about changes to our services.',
            sublist: [],
          },
        ],
      },
      {
        title: 'Your Right',
        titleHref: '#youright',
        text: 'You have the right to ask us not to process your personal data for marketing purposes. We will inform you (before collecting your data) if we intend to use your data for such purposes or if we intend to disclose your information to third parties for such purposes. You can exercise your right to prevent such processing by contacting us at ',
        text2:
          'Our site may contain links to and/or from the websites of our network of partners, advertisers and affiliates. If you follow a link to any of these websites, please note that these websites have their own privacy policies and we have no responsibility or liability for those policies. Please check this policy before you submit personal data to these websites.',
        list: [],
      },
      {
        title: 'Changes to Our Privacy Policy',
        titleHref: '#changestoour',
        text: 'Changes that we may make to our privacy policy in the future will be posted on this page and, where appropriate, will be notified to you by e-mail.',
        text2: '',
        list: [],
      },
      {
        title: 'Who can be Contacted',
        titleHref: '#contact',
        text2: '',
        text: 'Questions, comments and suggestions regarding this privacy policy will be welcomed and can be delivered to the following address:',
        list: [],
      },
    ],
  };